module.exports = __webpack_public_path__ + "img/campaign_text.eba7dd02.svg";